import { TbMessageChatbotFilled, TbMinus } from "react-icons/tb";
// import { SiChatbot } from "react-icons/si";
// import { MessageCircle } from "lucide-react";
import { TiHome } from "react-icons/ti";
import { LuMessagesSquare, LuSendHorizontal } from "react-icons/lu";
import Chatbot from "./Chatbot";
import { useChat } from "../../hook/useChat";
import NewUser from "./NewUser";
import { useAuth } from "../../hook/useAuth";
import './style.css';
import { Link } from "react-router-dom";
// import { ReactComponent as Logo } from '195.svg';

const Hero = () => {
  
  const { user } = useAuth();
  const { isOpen, isChatActive, handleChatOpen, handleBack, toggleChat } = useChat();

  return (
    <div className="hero-container">
      {!isOpen  ? (
        <button className="chat-toggle-button" onClick={toggleChat}>
          <img src="/195.svg" width="130" height="130" alt="logo" />
        </button>
      ) : (
        <div className="chat-box">
          {isChatActive ? (
            <Chatbot onBack={handleBack} toggleChat={toggleChat}/>
          ) : (
            <>
              <div className="hero-header">
                <div className="hero-header-content">
                  <div className="hero-icon-large">
                    <TbMessageChatbotFilled/>
                  </div>
                  <button className="chat-minimize-button" onClick={toggleChat}>
                    <TbMinus />
                  </button>
                </div>
                <h1 className="chat-title">How can we help you today ? 👋</h1>
              </div>

              <div className="hero-body">
                {!user ? (
                  <NewUser />
                ) : (
                  <div className="chat-welcome">
                    {/* <div className="chat-welcome-content">
                      <SiChatbot className="chat-welcome-icon"/>
                    </div> */}
                    <button className="chat-start-button" onClick={handleChatOpen}>
                      Chat with Us <LuSendHorizontal className="chat-send-icon" />
                    </button>
                  </div>
                )}
                <div className="hero-footer">
                  <Link to={'/'} className="hero-footer-item">
                    <TiHome className="hero-footer-icon" />
                    Home
                  </Link>
                  <Link to={'/contact'} className="hero-footer-item">
                    <LuMessagesSquare className="hero-footer-icon" />
                    Contact
                  </Link>
                </div>
              </div>
              <p className="mini-footer"><span id="p-tag">Powered by</span> <img className="logo" src="logo.png" alt="logo" />  <span id="ai-tag">AI</span></p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Hero;
